(function () {
  'use strict';

  function setVendor(){
    var input = document.getElementById('omgrfq-formShippingAddress_0-native');
    if (!input) {
      return;
    }

    window.omgSetSelect('omgrfq-formShippingAddress_0', window.EZ.current_country)
  }

  function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  function init() {
    document.addEventListener('change', function (event) {
      if (event.target.id === 'omgrfq-formCustomerInfo_0') {
        setVendor();
      }
    });
    document.addEventListener('input', function (event) {
      if (event.target.id === 'omgrfq-formCustomerInfo_0') {
        setVendor();
      }
    });
    document.addEventListener('click', function(event) {
      const target = event.target.closest('.m-nav.m-nav-image');
      
      if (target && target.classList.contains('m-nav-image')) {
        event.preventDefault();
        document.querySelector('.small-promo-content--link').click();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

window.omgSetSelect = function (name, value) {
  const root = document.querySelector('#app-quotes')?._vnode?.component
            || window.OMGRFQGlobalVariables?._instance;
  if (!root) throw new Error('OMGRFQ aún no está montado');

  const fields = [];
  const walkVNode = v => {
    if (!v) return;
    if (v.component) walk(v.component);
    if (Array.isArray(v.children)) v.children.forEach(walkVNode);
  };
  const walk = inst => {
    if (!inst) return;
    const p = inst.proxy;
    const el = p?.$el;
    // solo el componente del campo: raíz .omgrfq-input + proxy como hijo directo
    if (el && el.classList?.contains('omgrfq-input')
        && el.querySelector(':scope > .omgrfq-select-native-proxy')
        && p.formInput
        && 'select' in p.$data) {
      fields.push(p);
    }
    walkVNode(inst.subTree);
  };
  walk(root);
  
  const comp = fields.find(c =>
    c.$el.querySelector(':scope > .omgrfq-select-native-proxy').name === name);
  if (!comp) throw new Error('Campo no encontrado: ' + name);

  const opts = [
    ...(comp.rankedCountryOptions || []),
    ...(comp.rankedStatesOptions || []),
    ...(comp.selectValueOptions || []),
    ...(comp.defaultOptions || []),
  ];
  const type = comp.formInput.type;
  let val;
  if (type === 'select-value' || type === 'country' || type === 'state') {
    val = opts.find(o => o.value === value || o.label === value)?.value ?? value;
  } else {
    val = opts.find(o => o.label === value || o.value === value)?.label ?? value;
  }

  comp.select = val; // el watcher sincroniza store + validación + input nativo
  return comp.select;
};